<template>
  <div class="simple-layout">
    <div class="simple-header" v-if="showHeader">
      <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center">
          <div class="logo">
            <router-link to="/">
              <img src="@/assets/images/logo/romas.png" alt="ROMAS" style="max-height: 50px;">
            </router-link>
          </div>
          <div class="header-actions">
            <button class="btn btn-secondary" @click="goBack">
              <i class="fa fa-arrow-left"></i> Retour
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="simple-content">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

// Layout simple sans menu, sidebar ou footer
// Utilisé pour les pages qui ont besoin d'être affichées en plein écran
const showHeader = ref(true); // Peut être passé via meta route si besoin
const router = useRouter();

const goBack = () => {
  router.go(-1);
};
</script>

<style scoped>
.simple-layout {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.simple-header {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  margin-bottom: 20px;
}

.simple-content {
  padding: 20px 0;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>
